import { BrowserTracing, init } from '@sentry/browser';

import clientConfig from '../client/config';

export async function initClientSideSentry() {
  const {
    enabled,
    dsn,
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    enableSessionReplay,
  } = clientConfig.sentry;

  init({
    enabled,
    dsn,
    release: `jg-pages-edge@${process.env.SERVICE_VERSION}`,
    dist: `client-${process.env.ENVIRONMENT}`,
    environment: process.env.ENVIRONMENT,
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    allowUrls: [clientConfig.justGivingRootUrl],
    ignoreErrors: [
      /CookieConsent/,
      'Load failed',
      /twttr/,
      /Illegal invocation/,
      /ChunkLoadError/,
      /heap.push is not a function/,
    ],
    integrations: [new BrowserTracing()],
  });

  if (enableSessionReplay) {
    const { getCurrentHub, Replay } = await import('@sentry/browser');
    const client = getCurrentHub().getClient();
    client?.addIntegration?.(
      new Replay({
        maskAllText: false,
      }),
    );
  }
}
